const maintenanceFlagMap = {
  ClienteFinal: "underMaintenanceMgAppClienteFinal",
  Agenciero: "underMaintenanceMgAppAgenciero",
  Interno: "underMaintenanceMgAppInterno",
  Productor: "underMaintenanceMgAppProductor",
  Gestor: "underMaintenanceMgAppGestor",
  Vendedor: "underMaintenanceMgAppVendedor",
  Supervisor: "underMaintenanceMgAppSupervisor",
};

export const isUserTypeInMaintenance = (flags, userType) => {
  //console.log({ ...flags, userType });
  if (!userType) return false;
  const flagKey = maintenanceFlagMap[userType];
  return !!flags[flagKey];
};
